module.exports = __webpack_public_path__ + "img/marker.2df13484.svg";